module.exports = __webpack_public_path__ + "static/media/multisapphero.0aea19e9.jpg";